import React from "react";
import { useSelector } from "react-redux";
import { ValidatePermission } from "../../utils/allowHelper/AllowHelper";
import { useGetUserByIdQuery } from "store/api/apiSlice";

const Can = ({ permissions, children, fallback = null }) => {
  const { user } = useSelector((state) => state.user);

  const { data: userProfile, isLoading: userLoading } = useGetUserByIdQuery(
    user.id,
    {
      skip: !user?.id,
      pollingInterval: 60000,
      refetchOnFocus: true,
      refetchOnReconnect: true,
    },
  );

  if (userLoading) return null;

  if (ValidatePermission(userProfile?.user, permissions) === false) {
    return fallback;
  }

  return <>{children}</>;
};

export default Can;
